
import { service } from './axios.js'
// 获取名人列表
export const celebrityList = function (params) {
	return service.post('/open/celebrity/list', params)
}
// 通过id去获取名人信息
export const getById = function (params) {
	return service.post(`/open/celebrity/getById?id=${params}`)
}